export default (theme) => ({
  container: {
    padding: 5,
  },
  paper: {
    minWidth: 740,
  },
});
